function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M17 15v-3a1 1 0 1 0-2 0v3h-3a1 1 0 1 0 0 2h3v3a1 1 0 1 0 2 0v-3h3a1 1 0 1 0 0-2h-3zm-1 9a8 8 0 1 1 0-16 8 8 0 0 1 0 16z"
});

var SvgAddSmall = function SvgAddSmall(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "9de713ab6892b7d79b6f9eac60fa12c8.svg";
export { SvgAddSmall as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/add-small.svg
// module id = null
// module chunks = 